"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var tabsAlign = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
};

var TabsView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .tab {\n    box-shadow: ", ";\n    background-color: ", ";\n    color: ", ";\n    opacity: 1;\n  }\n\n  .MuiTab-textColorInherit.Mui-selected {\n    color: ", ";\n  }\n\n  .MuiTabs-indicator {\n    background-color: ", ";\n  }\n\n  .MuiTabs-scroller {\n    flex: 0 1 auto;\n  }\n\n  .MuiTabs-root {\n    justify-content: ", ";\n  }\n\n  .MuiTabs-scrollButtons {\n    @media (max-width: 800px) {\n      display: inline-flex;\n    }\n  }\n"])), function (_ref) {
  var boxShadow = _ref.boxShadow;
  return boxShadow && "0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)";
}, function (_ref2) {
  var background = _ref2.background;
  return background;
}, function (_ref3) {
  var text = _ref3.text;
  return text;
}, function (_ref4) {
  var selectedColor = _ref4.selectedColor;
  return selectedColor;
}, function (_ref5) {
  var selectedColor = _ref5.selectedColor;
  return selectedColor;
}, function (_ref6) {
  var align = _ref6.align;
  return tabsAlign[align];
});

exports.TabsView = TabsView;

//# sourceMappingURL=Tabs.style.js.map